import { defineMessages } from 'react-intl-next';

const messages = defineMessages({
	title: {
		id: 'eoc.routing-rules.ui.title.no-translate',
		defaultMessage: 'Routing rules',
		description: 'Title of routing rules section',
	},
	add: {
		id: 'eoc.routing-rules.ui.add.no-translate',
		defaultMessage: 'Create routing rule',
		description: 'Label of add routing rule button',
	},
});

export default messages;
